import React, { useState } from 'react';
import API from '../services/apiConfig';

const DeleteAccount = () => {
  const [step, setStep] = useState('form'); // 'form' | 'confirm' | 'done' | 'error'
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStep('confirm');
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setErrorMsg('');
    try {
      await API.post('/auth/request-delete-account', { email, reason });
      setStep('done');
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        'Failed to submit request. Please email us directly at app@shineling.org.';
      setErrorMsg(msg);
      setStep('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: 600 }}>
      <h2 className="mb-2">Delete Account</h2>
      <p className="text-muted mb-4">
        GoDhamma (走，修行吧！) — Pertubuhan Meditasi Shi Ne Ling, Malaysia
      </p>

      {step === 'form' && (
        <>
          <div className="alert alert-warning">
            <strong>What gets deleted:</strong>
            <ul className="mb-0 mt-2">
              <li>Your login account (email &amp; password)</li>
              <li>Retreat registration records linked to your account</li>
              <li>Practice data (Bodhi Tree meditation records)</li>
              <li>Push notification token</li>
              <li>Any linked retreat student profile</li>
            </ul>
          </div>
          <div className="alert alert-info">
            <strong>What is retained:</strong> Administrative retreat records required for
            legal or operational purposes may be retained even after account deletion. See our{' '}
            <a href="/retreat-my/privacy-policy">Privacy Policy</a> for details.
          </div>

          <form onSubmit={handleSubmit} className="mt-4">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Email address on your account <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>
            <div className="mb-4">
              <label className="form-label fw-semibold">
                Reason for deletion (optional)
              </label>
              <textarea
                className="form-control"
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="e.g. No longer using the app"
              />
            </div>
            <button type="submit" className="btn btn-danger w-100">
              Request Account Deletion
            </button>
          </form>
        </>
      )}

      {step === 'confirm' && (
        <div className="text-center">
          <div className="alert alert-danger">
            <h5>Are you sure?</h5>
            <p className="mb-0">
              You are requesting deletion of the account associated with{' '}
              <strong>{email}</strong>. This action cannot be undone.
            </p>
          </div>
          <div className="d-flex gap-3 justify-content-center mt-3">
            <button
              className="btn btn-outline-secondary"
              onClick={() => setStep('form')}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Submitting…' : 'Yes, delete my account'}
            </button>
          </div>
        </div>
      )}

      {step === 'done' && (
        <div className="alert alert-success text-center">
          <h5>Request received</h5>
          <p className="mb-0">
            We have received your account deletion request for <strong>{email}</strong>.
            Your account will be deleted within <strong>30 days</strong>. You will receive
            a confirmation email when the deletion is complete.
          </p>
        </div>
      )}

      {step === 'error' && (
        <div>
          <div className="alert alert-danger">{errorMsg}</div>
          <button className="btn btn-outline-secondary" onClick={() => setStep('form')}>
            Try again
          </button>
        </div>
      )}

      <hr className="mt-5" />
      <p className="text-muted small">
        Alternatively, email us directly at{' '}
        <a href="mailto:app@shineling.org">app@shineling.org</a> with subject line
        "Account Deletion Request".
      </p>
    </div>
  );
};

export default DeleteAccount;
